import { render, staticRenderFns } from "./TextPart.vue?vue&type=template&id=295bc69f&"
import script from "./TextPart.vue?vue&type=script&lang=js&"
export * from "./TextPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextPart.vue"
export default component.exports